import { markRaw } from "vue";
import { makeRef } from "@/components/composables/reactivityTypes";
import Guid from "@/app/types/common/guid";
import type { ComponentPublicInstanceConstructor } from "vue/types/v3-component-public-instance";

export interface OpenDialog {
  id: string;
  component: ComponentPublicInstanceConstructor;
  props: Record<string, any>;
  attrs: Record<string, any>;
  onAccept: (value: any) => void;
  onCancel: () => void;
}

export const openDialogs = makeRef<readonly OpenDialog[]>([]);

export function pushDialog(entry: Omit<OpenDialog, "id">): string {
  const id = Guid.create().toString();
  openDialogs.value = openDialogs.value.concat({
    ...entry,
    id,
    // The component constructor must never be made reactive.
    component: markRaw(entry.component),
  });
  return id;
}

export function removeDialog(id: string): void {
  openDialogs.value = openDialogs.value.filter((d) => d.id !== id);
}
